import { HttpHeaders } from '@angular/common/http';

export class HttpCallLog {
    constructor(public url: string, public headers: HttpHeaders, public method: string){}
}

export class WebsocketEventLog {
    constructor(public projectId: string, public eventData: any){}
}
